/**
 * Created by Christof Sander on 05.04.2017.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		subFormAliasContainer: 				'children',
		subFormAlias: 						's_services_users_scopeRoles',
		subFormPrimaryKey: 					'serviceUserScopeRoleID',
		setUserPropertiesLastModifiedTS: 	true
	},

	model: {
		toggleData: {},
		dirtyData: {},
		scopeRoleAssignmentResources: {}
	},

	methods: {
		sanitizeResources(storage){
			this.model.toggleData = {};

			if(this.resourceData && this.resourceData.data){
				var scope, scopeID, scopeIndex, scopeRole, scopeRoleID, scopeRoleIndex;
				for(scopeIndex in this.resourceData.data){
					scope = this.resourceData.data[scopeIndex];
					scopeID = scope.attributes[scope.primaryKey];
					this.model.toggleData[scopeID] = {
						options: 	[
							{
								value: '',
								name: storage.__('dataValues.options.none')
							}
						],
						name: 		scope.attributes.name
					};

					if(scope.children && scope.children.um_scopeRoles && scope.children.um_scopeRoles.data){
						for(scopeRoleIndex in scope.children.um_scopeRoles.data){
							scopeRole 	= scope.children.um_scopeRoles.data[scopeRoleIndex];
							scopeRoleID = scopeRole.attributes[scopeRole.primaryKey]
							this.model.toggleData[scopeID].options.push({
								value: scopeRoleID,
								name: scopeRole.attributes.name
							});
						}
					}
				}
			}
		},

		selectScopeRoles: function(scopeRoles){
			var scopeRoleIndex,
				scopeRole,
				scopeRoleID,
				scopeID,
				availableScopeRoles,
				scopeRoleOptionIndex,
				scopeIdentified,
				$scopeToggle
			;

			for(scopeID in this.model.toggleData){
				availableScopeRoles = this.model.toggleData[scopeID];
				scopeIdentified = false;
				this.model.scopeRoleAssignmentResources[scopeID] = {};

				for(scopeRoleOptionIndex in availableScopeRoles.options){
					for(scopeRoleIndex in scopeRoles){
						scopeRole = scopeRoles[scopeRoleIndex].attributes;
						scopeRoleID = scopeRole.scopeRoleID;

						if(availableScopeRoles.options[scopeRoleOptionIndex].value == scopeRoleID){
							scopeIdentified = true;
							this.model.scopeRoleAssignmentResources[scopeID] = {};
							this.model.scopeRoleAssignmentResources[scopeID].scopeRoleID = scopeRoleID;
							this.model.scopeRoleAssignmentResources[scopeID][this.config.subFormPrimaryKey] = scopeRole[this.config.subFormPrimaryKey];

							if(($scopeToggle = this.$.find('[data-field-code="' + scopeID + '"]')).length > 0){
								getComponent($scopeToggle).select(scopeRoleID);
							}
							break;
						}
					}

					if(scopeIdentified){
						break;
					}
				}
			}
		}
	},

	hooks: {
		attach: function($element, triggerOptions){
			if(this.model.parentForm){
				this.model.parentForm.setClean();
			}
		},

		onChildChanged: function($element, triggerOptions){
			if(triggerOptions.fieldCode){
				var self = this;
				if(!this.model.parentForm){
					this.closest('base_form_form', function(parentFormComponent){
						self.model.parentForm = parentFormComponent;
					});
				}

				if(!self.model.parentForm.model.dirtyFields.data) 																	self.model.parentForm.model.dirtyFields.data = {};
				if(!self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer]) 								self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer] = {};
				if(!self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer][self.config.subFormAlias]) 		self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer][self.config.subFormAlias] = {};
				if(!self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer][self.config.subFormAlias].data) self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer][self.config.subFormAlias].data = [];

				var scopeRolesData = self.model.parentForm.model.dirtyFields.data[self.config.subFormAliasContainer][self.config.subFormAlias].data;
				var scopeRoleAssignment = this.model.scopeRoleAssignmentResources[triggerOptions.fieldCode] || {};

				// ready to change scopeRole
				if(scopeRoleAssignment.scopeRoleID != triggerOptions.value){
					if(self.config.setUserPropertiesLastModifiedTS){
						if(!self.model.parentForm.model.dirtyFields.data.attributes) self.model.parentForm.model.dirtyFields.data.attributes = {};
						self.model.parentForm.model.dirtyFields.data.attributes.userPropertiesLastModified = new Date().toISOString();
					}

					// ready to remove old scopeRole
					if(scopeRoleAssignment[self.config.subFormPrimaryKey]){
						var deleteEntry = {
							attributes: {},
							type: 'delete'
						};
						deleteEntry.attributes[self.config.subFormPrimaryKey] = scopeRoleAssignment[self.config.subFormPrimaryKey];
						scopeRolesData.push(deleteEntry);
					}

					// ready to add scopeRole
					if(triggerOptions.value){
						scopeRolesData.push({
							attributes: {
								scopeRoleID: triggerOptions.value
							}
						});
					}

					self.model.parentForm.setDirty();
				}
			}
		}
	}
};
